import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import LegalLayout from "../../layouts/LegalLayout";

const PrivacyPolicy: React.FC = () => {
  const { t } = useTranslation();

  return (
    <LegalLayout>
      <Box sx={{ py: 4 }}>
        <Typography variant="h2" component="h1" gutterBottom>
          {t("legal.privacyPolicy.title")}
        </Typography>
        <Typography variant="body1">
          <strong>{t("legal.privacyPolicy.intro")}</strong>
          <br />
          <br />
          <strong>{t("legal.privacyPolicy.controller.title")}</strong>
          <br />
          {t("legal.privacyPolicy.controller.name")}
          <br />
          {t("legal.privacyPolicy.controller.nif")}
          <br />
          {t("legal.privacyPolicy.controller.address")}
          <br />
          {t("legal.privacyPolicy.controller.contact")}
          <br />
          <br />
          <strong>{t("legal.privacyPolicy.dataCollection.title")}</strong>
          <br />
          {t("legal.privacyPolicy.dataCollection.description")}
          <br />
          <br />
          <strong>{t("legal.privacyPolicy.purposes.title")}</strong>
          <br />
          {t("legal.privacyPolicy.purposes.description")}
          <br />
          <br />
          <strong>{t("legal.privacyPolicy.rights.title")}</strong>
          <br />
          {t("legal.privacyPolicy.rights.description")}
          <br />
          <br />
          <strong>{t("legal.privacyPolicy.security.title")}</strong>
          <br />
          {t("legal.privacyPolicy.security.description")}
          <br />
          <br />
          <strong>{t("legal.privacyPolicy.updates.title")}</strong>
          <br />
          {t("legal.privacyPolicy.updates.description")}
          <br />
          <br />
          <strong>{t("legal.privacyPolicy.sections.candidates.title")}</strong>
          <br />
          <strong>
            {t("legal.privacyPolicy.sections.candidates.purpose")}
          </strong>
          <br />
          {t("legal.privacyPolicy.sections.candidates.legitimation")}
          <br />
          {t("legal.privacyPolicy.sections.candidates.recipients")}
          <br />
          {t("legal.privacyPolicy.sections.candidates.rights")}
          <br />
          {t("legal.privacyPolicy.sections.candidates.origin")}
          <br />
          <br />
          <strong>{t("legal.privacyPolicy.sections.clients.title")}</strong>
          <br />
          <strong>{t("legal.privacyPolicy.sections.clients.purpose")}</strong>
          <br />
          {t("legal.privacyPolicy.sections.clients.legitimation")}
          <br />
          {t("legal.privacyPolicy.sections.clients.recipients")}
          <br />
          {t("legal.privacyPolicy.sections.clients.rights")}
          <br />
          {t("legal.privacyPolicy.sections.clients.origin")}
          <br />
          <br />
          <strong>
            {t("legal.privacyPolicy.sections.potentialClients.title")}
          </strong>
          <br />
          <strong>
            {t("legal.privacyPolicy.sections.potentialClients.purpose")}
          </strong>
          <br />
          {t("legal.privacyPolicy.sections.potentialClients.legitimation")}
          <br />
          {t("legal.privacyPolicy.sections.potentialClients.recipients")}
          <br />
          {t("legal.privacyPolicy.sections.potentialClients.rights")}
          <br />
          {t("legal.privacyPolicy.sections.potentialClients.origin")}
          <br />
          <br />
          <strong>{t("legal.privacyPolicy.sections.suppliers.title")}</strong>
          <br />
          <strong>{t("legal.privacyPolicy.sections.suppliers.purpose")}</strong>
          <br />
          {t("legal.privacyPolicy.sections.suppliers.legitimation")}
          <br />
          {t("legal.privacyPolicy.sections.suppliers.recipients")}
          <br />
          {t("legal.privacyPolicy.sections.suppliers.rights")}
          <br />
          {t("legal.privacyPolicy.sections.suppliers.origin")}
          <br />
          <br />
          <strong>{t("legal.privacyPolicy.sections.staff.title")}</strong>
          <br />
          <strong>{t("legal.privacyPolicy.sections.staff.purpose")}</strong>
          <br />
          {t("legal.privacyPolicy.sections.staff.legitimation")}
          <br />
          {t("legal.privacyPolicy.sections.staff.recipients")}
          <br />
          {t("legal.privacyPolicy.sections.staff.rights")}
          <br />
          {t("legal.privacyPolicy.sections.staff.origin")}
          <br />
          <br />
          <strong>
            {t("legal.privacyPolicy.sections.rightsRequests.title")}
          </strong>
          <br />
          <strong>
            {t("legal.privacyPolicy.sections.rightsRequests.purpose")}
          </strong>
          <br />
          {t("legal.privacyPolicy.sections.rightsRequests.legitimation")}
          <br />
          {t("legal.privacyPolicy.sections.rightsRequests.recipients")}
          <br />
          {t("legal.privacyPolicy.sections.rightsRequests.rights")}
          <br />
          {t("legal.privacyPolicy.sections.rightsRequests.origin")}
        </Typography>
      </Box>
    </LegalLayout>
  );
};

export default PrivacyPolicy;
